<template>
  <v-card tile flat class="my-5">
    <v-card-text class="pa-0">
      <v-row no-gutters>
        <v-col cols="2">
          <div class="bg-kiri"></div>
        </v-col>
        <v-col cols="10" class="pa-5">
          <h1 class="headline info--text">
            {{ pspPeringkat.k_tahap_peringkat_psp === 10 ? '5. Selesai' : '4. Berita Acara' }}
          </h1>
          <h3 class="black--text font-weight-regular">
            Selamat! Proses Penentuan Kepala Sekolah Terpilih pada PSP Angkatan {{ pspPeringkat.gelombang }} Telah
            Selesai
          </h3>
          <template v-if="pspPeringkat.k_tahap_peringkat_psp === 10">
            <p class="body-2 mt-4 black--text">
              Tahapan pada pembuatan borang peringkat Program Sekolah Penggerak telah selesai. untuk melihat hasil
              akhirnya, Anda dapat melihat pada detil informasi yang telah tersedia. Jika terdapat kebutuhan lainterkait
              borang peringkat ini dapat menghubungi langsung pihak pusat
            </p>
          </template>
          <template v-else-if="[6, 7, 9].includes(pspPeringkat.k_tahap_peringkat_psp)">
            <p class="body-2 mt-4 black--text">
              Konfirmasi dari pusat telah dikirimkan kembali pada tanggal <strong>{{ getInfoSetuju }}.</strong> Anda
              diharuskan untuk mengunduh berkas berita acara, mengisikan tanda tangan dengan pihak terkait pada berkas
              cetak dan kemudian mengunggahnya.
            </p>
            <v-alert colored-border class="pa-2 my-2 bg-notif" color="warning" style="border-width: 0 !important;">
              <v-row no-gutters style="flex-wrap: nowrap">
                <v-col cols="1" class="flex-grow-1 flex-shrink-0 my-auto" style="max-width: 50px">
                  <v-icon class="mx-2 orange--text">mdi-alert</v-icon>
                </v-col>
                <v-col cols="11" class="flex-grow-1 flex-shrink-0 my-auto">
                  <p class="body-2 mb-0 black--text">
                    Jika Anda telah mengunduh berkas berita acara, mengisikan tanda tangan dengan pihak terkait pada
                    berkas cetak, dan kemudian mengunggahnya, klik BA Sudah Sesuai untuk menyelesaikan seluruh tahapan
                    pengisian Borang Peringkat.
                  </p>
                </v-col>
              </v-row>
              <v-row no-gutters style="flex-wrap: nowrap">
                <v-col cols="1" class="flex-grow-1 flex-shrink-0 my-auto" style="min-width: 40px; max-width: 50px">
                  &nbsp;
                </v-col>
                <v-col cols="11" class="flex-grow-1 flex-shrink-0 my-auto">
                  <v-btn
                    class="mt-2 white--text"
                    color="orange"
                    small
                    style="text-transform: unset"
                    depressed
                    :disabled="!pspPeringkat.file_ba || !$allow('psp-peringkat-dinas.ba-selesai')"
                    @click="onAjuan"
                  >
                    <v-icon left dark>
                      mdi-send
                    </v-icon>
                    BA Sudah Sesuai
                  </v-btn>
                </v-col>
              </v-row>
            </v-alert>
            <v-alert
              v-if="pspPeringkat.k_tahap_peringkat_psp === 9"
              colored-border
              class="pa-2 my-2 bg-error"
              color="warning"
              style="border-width: 0 !important;"
            >
              <v-row no-gutters style="flex-wrap: nowrap">
                <v-col cols="1" class="flex-grow-1 flex-shrink-0 my-auto" style="max-width: 50px">
                  <v-icon class="mx-2 red--text">mdi-alert</v-icon>
                </v-col>
                <v-col cols="11" class="flex-grow-1 flex-shrink-0 my-auto">
                  <p class="body-2 mb-0 black--text">
                    Ajuan Berita Acara telah <strong>Ditolak oleh Pusat</strong> pada tanggal
                    <strong>{{ getInfoTolak }}</strong> dengan alasan berikut:
                    <br />
                    <strong v-if="getAlasanTolak">"{{ getAlasanTolak }}"</strong>
                  </p>
                </v-col>
              </v-row>
            </v-alert>
          </template>
          <template v-else>
            <v-alert colored-border class="pa-2 my-2 green lighten-4" style="border-width: 0 !important;">
              <v-row no-gutters style="flex-wrap: nowrap">
                <v-col cols="1" class="flex-grow-1 flex-shrink-0 my-auto" style="max-width: 50px">
                  <v-icon class="mx-2 green--text">mdi-check-outline</v-icon>
                </v-col>
                <v-col cols="11" class="flex-grow-1 flex-shrink-0 my-auto">
                  <p class="body-2 mb-0 black--text">
                    Pada tahap ini Anda hanya menunggu proses verval berita acara dari pusat. Pihak pusat akan segera
                    melakukan verval berkas berita acara yang telah Anda kirimkan. Jika berita acara tersebut sudah
                    sesuai, Anda dapat melanjutkan ke tahap selanjutnya. Jika belum sesuai, Anda diharuskan untuk
                    melakukan perbaikan sesuai umpan balik dari pusat.
                    <br />
                    Anda telah mengirimkan berkas berita acara pada tanggal:
                  </p>
                  <span class="subtitle-1 secondary--text">{{ getInfoAjuan }} WIB</span>
                </v-col>
              </v-row>
            </v-alert>
          </template>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
  name: 'konfirmasi-content',

  computed: {
    ...mapState('peringkat', {
      pspPeringkat: (state) => state.psp_peringkat || {},
    }),

    getInfoSetuju() {
      const tahaps = (this.pspPeringkat && this.pspPeringkat.psp_peringkat_tahaps) || [];
      const tahap = tahaps.filter((tahap) => +tahap.k_tahap_peringkat_psp === 5);

      return this.$localDate((tahap[0] && tahap[0]['wkt_proses']) || '', false, true);
    },

    getInfoAjuan() {
      const tahaps = (this.pspPeringkat && this.pspPeringkat.psp_peringkat_tahaps) || [];
      const tahap = tahaps.filter((tahap) => +tahap.k_tahap_peringkat_psp === 8);

      return this.$localDate((tahap[0] && tahap[0]['wkt_proses']) || '', false, true);
    },

    getInfoTolak() {
      const tahaps = (this.pspPeringkat && this.pspPeringkat.psp_peringkat_tahaps) || [];
      const tahap = tahaps.filter((tahap) => +tahap.k_tahap_peringkat_psp === 9);

      return this.$localDate((tahap[0] && tahap[0]['wkt_proses']) || '', false, true);
    },

    getAlasanTolak() {
      const tahaps = (this.pspPeringkat && this.pspPeringkat.psp_peringkat_tahaps) || [];
      const tahap = tahaps.filter((tahap) => +tahap.k_tahap_peringkat_psp === 9);

      return (tahap[0] && tahap[0]['catatan']) || '';
    },
  },

  methods: {
    ...mapActions('peringkat', ['save']),

    onAjuan() {
      const msg = [
        '<p class="subtitle-1 black--text">Apakah Anda yakin bahwa berkas berita acara yang sudah diunggah sudah benar ?</p>',
        '<p class="body-2">Proses ini akan mengkonfirmasi bahwa berkat berita acara sudah benar dan semua data kepala sekolah ',
        `yang terlampir akan menjadi Peserta yang sah diterima dalam PSP Angkatan ${this.pspPeringkat.gelombang} berdasarkan hasil pemeringkatan Kepala Sekolah.</p>`,
      ].join('');

      this.$confirm(msg, 'Konfirmasi Dokumen Berita Acara').then(() => {
        this.save({ type: 'ba-selesai' }).then(() => {
          this.$success('Dokumen berita acara berhasil disimpan');
          this.$emit('reload');
        });
      });
    },
  },
};
</script>

<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
</style>
